import { initializeApp, getApp } from "firebase/app";
import {
  createUserWithEmailAndPassword,
  FacebookAuthProvider,
  getAuth,
  GoogleAuthProvider,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  sendPasswordResetEmail,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import { Observable } from "rxjs";
import { OAuthProvider, updateEmail } from "firebase/auth";
import { getStorage } from "firebase/storage";

export let getCurrentSignedInUser = () => {
  return new Observable((observer) => {
    const app = initializeApp(firebaseConfig());
    const auth = getAuth(app);
    const storage = getStorage(app);
    onAuthStateChanged(auth, (user) => {
      if (user || null || undefined || '') {
        observer.next({ state: "logged in", user: user });
      } else {
        observer.next({ state: "logged out" });
      }
    });
  });
};

//staging
export let firebaseConfig = () => {
  return {
    apiKey: "AIzaSyCfvmDEI_7ZYG7JUp7ZGW3ucUe6u3SeuYU",
    authDomain: "playbook-da724.firebaseapp.com",
    projectId: "playbook-da724",
    storageBucket: "playbook-da724.firebasestorage.app",
    messagingSenderId: "862220503534",
    appId: "1:862220503534:web:4cb23e1c64811a5442e6ff",
    measurementId: "G-GDMTCEBX09"
  };
};

//production
export let firebaseConfigProduction = () => {
  return {
    apiKey: "AIzaSyCfvmDEI_7ZYG7JUp7ZGW3ucUe6u3SeuYU",
    authDomain: "playbook-da724.firebaseapp.com",
    projectId: "playbook-da724",
    storageBucket: "playbook-da724.firebasestorage.app",
    messagingSenderId: "862220503534",
    appId: "1:862220503534:web:4cb23e1c64811a5442e6ff",
    measurementId: "G-GDMTCEBX09"
  };
 
};


export let storageModule = () => {
  const app = getApp();
  if (!app) {
    const app = initializeApp(firebaseConfig());
    const storage = getStorage(app);
    return storage;
  }
  else {
    const storage = getStorage(app);
    return storage;
  }
}


export let CreatePasswordBasedAccount = (auth, email, password) => {
  return new Promise((resolve, reject) => {
    createUserWithEmailAndPassword(auth, email, password)
      .then((userCrendetial) => resolve(userCrendetial))
      .catch((error) => {
        const code = error?.code || "";
        if (code === "auth/email-already-in-use") {
          reject("This email is already registered. Please log in.");
        } else if (code === "auth/weak-password") {
          reject("Password is too weak. Use at least 8 characters with an uppercase letter, a number and a symbol.");
        } else if (code === "auth/invalid-email") {
          reject("Please enter a valid email address.");
        } else {
          reject(error?.message || "Unable to create account. Please try again.");
        }
      });
  });
};

export let loginPasswordBasedAccount = (auth, email, password) => {
  return new Promise((resolve, reject) => {
    setPersistence(auth, browserLocalPersistence).then(() => {
      signInWithEmailAndPassword(auth, email, password).then((userCredential) => {
        resolve(userCredential)
      }).catch((error) => {
        const code = error?.code || "";
        if (code === "auth/user-not-found") {
          reject("User not found. Check your registered email ID");
        } else if (
          code === "auth/wrong-password" ||
          code === "auth/invalid-credential" ||
          code === "auth/invalid-login-credentials"
        ) {
          reject("Incorrect email or password. Please try again.");
        } else if (code === "auth/too-many-requests") {
          reject("Too many failed attempts. Please try again later.");
        } else {
          reject(error?.message || "Unable to sign in. Please try again.");
        }
      });
    }).catch((error) => {
      reject(error?.message || "Unable to complete sign in. Please try again.");
    });
  });
};

export let getFirebaseAuthJWTToken = async (auth) => {
  return auth.currentUser.getIdToken(true);
};

export let getGoogleProvider = () => {
  const provider = new GoogleAuthProvider();
  provider.addScope("profile email");
  return provider;
};

export let getFacebookProvider = () => {
  const provider = new FacebookAuthProvider();
  provider.addScope("public_profile");
  return provider;
};

export let signinWithApple = () => {
  const provider = new OAuthProvider('apple.com');
  provider.addScope('email');
  provider.addScope('name');
  return provider;

}

export let getFirebaseAuthModule = () => {
  const app = initializeApp(firebaseConfig());
  const auth = getAuth(app);
  return auth;
};

export let doSignOut = (auth) => {
  return auth.signOut();
}
export let updateEmailId = (email) => {
  const auth = getAuth();
  auth.currentUser.getIdToken(true)
    .then(idToken => {
      return new Promise((resolve, reject) => {
        updateEmail(auth.currentUser, email).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        });
      })
    })
    .catch(error => {
      if (error.code === "auth/user-token-expired") {
      }
    })
}
export let sendFirebasePasswordResetEmail = (auth, email) => {
  return new Promise((resolve, reject) => {
    var actionCodeSettings = {
      url: window.location.origin
    };
    sendPasswordResetEmail(auth, email, actionCodeSettings)
      .then((success) => {
        resolve(success);
      })
      .catch((error) => {
        reject(error);
      });
  });

}

export let getFacebookEmail = (token) => {
  return new Promise((resolve, reject) => {
    var graphUrl = 'https://graph.facebook.com/me?fields=id,name,email&scope=email&access_token=' + token;
    fetch(graphUrl, {
      method: "GET",
      mode: "cors",
      cache: "no-cache"
    })
      .then((response) => {
        resolve(response.json());
      })
      .catch((error) => {
        if (error.code === "auth/user-not-found") {
          reject("User not found");
        }

      });
  });

}

export let getUserLoginStatus = () => {
  const auth = getFirebaseAuthModule();
}


const ModulesExported = {
  getFirebaseAuthModule,
  firebaseConfig,
  firebaseConfigProduction,
  getFirebaseAuthJWTToken,
  CreatePasswordBasedAccount,
  loginPasswordBasedAccount,
  getGoogleProvider,
  getFacebookProvider,
  getCurrentSignedInUser,
  doSignOut,
  sendFirebasePasswordResetEmail,
  getFacebookEmail,
  signinWithApple,
  storageModule,
  getUserLoginStatus,
  updateEmailId

};
export default ModulesExported;
